// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate, Link } from 'react-router-dom';
// import { 
//   FiCalendar,
//   FiChevronLeft,
//   FiEye,
//   FiEdit,
//   FiPlus,
//   FiCheckCircle,
//   FiXCircle,
//   FiRefreshCw,
//   FiFileText,
//   FiHome,
//   FiUser
// } from 'react-icons/fi';
// import {
//   MdHistory,
//   MdAttachMoney,
//   MdAssessment,
//   MdArrowDropDown,
//   MdReceiptLong
// } from 'react-icons/md';

// const TaxHistory = () => {
//   const { propertyId } = useParams();
//   const navigate = useNavigate();
//   const [language, setLanguage] = useState('english');
//   const [selectedYear, setSelectedYear] = useState('2024-25');
//   const [loading, setLoading] = useState(true);
//   const [propertyData, setPropertyData] = useState(null);

//   // Government of Maharashtra color scheme
//   const colors = {
//     primary: '#003366',
//     secondary: '#FF9933',
//     accent: '#138808',
//     lightBlue: '#E6F0FF',
//     lightOrange: '#FFF0E6',
//     lightGreen: '#E6FFE6',
//     white: '#FFFFFF',
//     dark: '#1E293B',
//     gray: '#64748B'
//   };

//   // Available assessment years (current and previous 4 years)
//   const assessmentYears = [
//     '2028-29',
//     '2027-28',
//     '2026-27',
//     '2025-26',
//     '2024-25',
//     '2023-24',
//     '2022-23',
//     '2021-22'
//   ];

//   // Sample property data
//   const sampleProperty = {
//     id: propertyId || 'PR-2024-1001',
//     sequenceNumber: 'PR-2024-1001',
//     ownerName: 'राजेश कुमार',
//     newPropertyNumber: 'NPR-24001',
//     oldPropertyNumber: 'OPR-20101',
//     address: 'शिवाजी नगर, पुणे',
//     propertyType: 'Residential',
//     registrationDate: '15 जानेवारी 2024'
//   };

//   // Sample tax history data
//   const sampleTaxHistory = {
//     '2028-29': [
//       { id: 1, year: '2028-29', totalTax: 0, status: 'not-calculated' },
//     ],
//     '2027-28': [
//       { id: 2, year: '2027-28', totalTax: 0, status: 'not-calculated' },
//     ],
//     '2026-27': [
//       { id: 3, year: '2026-27', totalTax: 0, status: 'not-calculated' },
//     ],
//     '2025-26': [
//       { id: 4, year: '2025-26', totalTax: 0, status: 'not-calculated' },
//     ],
//     '2024-25': [
//       { 
//         id: 5, 
//         year: '2024-25', 
//         totalTax: 48260, 
//         status: 'calculated',
//         receiptNumber: 'RCPT-2024-001245',
//         paymentDate: '25 जानेवारी 2024',
//         dueDate: '31 मार्च 2025'
//       },
//     ],
//     '2023-24': [
//       { 
//         id: 6, 
//         year: '2023-24', 
//         totalTax: 45500, 
//         status: 'calculated',
//         receiptNumber: 'RCPT-2023-001089',
//         paymentDate: '20 मार्च 2024',
//         dueDate: '31 मार्च 2024'
//       },
//     ],
//     '2022-23': [
//       { 
//         id: 7, 
//         year: '2022-23', 
//         totalTax: 43200, 
//         status: 'calculated',
//         receiptNumber: 'RCPT-2022-000956',
//         paymentDate: '15 मार्च 2023',
//         dueDate: '31 मार्च 2023'
//       },
//     ],
//     '2021-22': [
//       { 
//         id: 8, 
//         year: '2021-22', 
//         totalTax: 41000, 
//         status: 'calculated',
//         receiptNumber: 'RCPT-2021-000812',
//         paymentDate: '10 मार्च 2022',
//         dueDate: '31 मार्च 2022'
//       },
//     ]
//   };

//   // Language content
//   const content = {
//     english: {
//       pageTitle: 'Property Tax History',
//       pageSubtitle: 'View and manage tax records for this property',
//       propertyInfo: 'Property Information',
//       assessmentYear: 'Assessment Year',
//       selectYear: 'Select Assessment Year',
//       currentYear: 'Current Year',
//       taxHistory: 'Tax History',
//       tableHeaders: {
//         serial: 'Sr No',
//         assessmentYear: 'Assessment Year',
//         totalTax: 'Total Tax (₹)',
//         status: 'Status',
//         actions: 'Actions'
//       },
//       status: {
//         calculated: 'Calculated',
//         notCalculated: 'Not Calculated'
//       },
//       buttons: {
//         back: 'Back to Property List',
//         calculateTax: 'Calculate Tax (Current Year)',
//         refresh: 'Refresh',
//         view: 'View',
//         edit: 'Edit'
//       },
//       messages: {
//         loading: 'Loading tax history...',
//         noTaxForYear: 'No tax records found for selected year',
//         currentYearNotCalculated: 'Current year tax not calculated yet',
//         clickToCalculate: 'Click to calculate tax for current year',
//         taxCalculated: 'Tax already calculated for this year'
//       },
//       info: {
//         readOnly: 'Read-only information',
//         taxExists: 'Tax exists and calculated',
//         taxNotExists: 'Tax not calculated yet'
//       }
//     },
//     marathi: {
//       pageTitle: 'मालमत्ता कर इतिहास',
//       pageSubtitle: 'या मालमत्तेसाठी कर नोंदी पहा आणि व्यवस्थापित करा',
//       propertyInfo: 'मालमत्ता माहिती',
//       assessmentYear: 'मूल्यांकन वर्ष',
//       selectYear: 'मूल्यांकन वर्ष निवडा',
//       currentYear: 'चालू वर्ष',
//       taxHistory: 'कर इतिहास',
//       tableHeaders: {
//         serial: 'अनुक्रमांक',
//         assessmentYear: 'मूल्यांकन वर्ष',
//         totalTax: 'एकूण कर (₹)',
//         status: 'स्थिती',
//         actions: 'क्रिया'
//       },
//       status: {
//         calculated: 'गणित केले',
//         notCalculated: 'गणित केले नाही'
//       },
//       buttons: {
//         back: 'मालमत्ता यादीकडे परत',
//         calculateTax: 'कर मोजा (चालू वर्ष)',
//         refresh: 'रिफ्रेश',
//         view: 'पहा',
//         edit: 'सुधारा'
//       },
//       messages: {
//         loading: 'कर इतिहास लोड करत आहे...',
//         noTaxForYear: 'निवडलेल्या वर्षासाठी कर नोंदी आढळल्या नाहीत',
//         currentYearNotCalculated: 'चालू वर्षाचा कर अद्याप मोजला गेला नाही',
//         clickToCalculate: 'चालू वर्षासाठी कर मोजण्यासाठी क्लिक करा',
//         taxCalculated: 'या वर्षासाठी कर आधीच मोजला गेला आहे'
//       },
//       info: {
//         readOnly: 'केवळ वाचनासाठी माहिती',
//         taxExists: 'कर अस्तित्वात आहे आणि गणित केला आहे',
//         taxNotExists: 'कर अद्याप गणित केला गेला नाही'
//       }
//     }
//   };

//   // Format currency in Indian Rupees
//   const formatCurrency = (amount) => {
//     if (!amount || amount === 0) return '₹0';
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0
//     }).format(amount);
//   };

//   // Get current year
//   const getCurrentYear = () => {
//     const currentYear = new Date().getFullYear();
//     const nextYear = currentYear + 1;
//     return `${currentYear}-${nextYear.toString().slice(2)}`;
//   };

//   // Load data
//   useEffect(() => {
//     // Set current year as default
//     setSelectedYear(getCurrentYear());
    
//     // Simulate API call
//     setTimeout(() => {
//       setPropertyData(sampleProperty);
//       setLoading(false);
//     }, 1000);
//   }, [propertyId]);

//   // Handle year change
//   const handleYearChange = (year) => {
//     setSelectedYear(year);
//   };

//   // Handle view action
//   const handleView = (taxRecord) => {
//     // navigate(`/tax/pdf/${propertyId}/${taxRecord.year}`);
//     navigate(`/print-pdf`);
//   };

//   // Handle edit action
//   const handleEdit = (taxRecord) => {
//     navigate(`/calculate-tax/${propertyId}?year=${taxRecord.year}`);
//   };

//   // Handle calculate current year tax
//   const handleCalculateCurrentYear = () => {
//     const currentYear = getCurrentYear();
//     navigate(`/calculate-tax/${propertyId}?year=${currentYear}`);
//   };

//   // Handle back to property list
//   const handleBack = () => {
//     navigate('/property-list');
//   };

//   // Get current tax history
//   const currentTaxHistory = sampleTaxHistory[selectedYear] || [];

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50">
//         <div className="text-center">
//           <div className="w-16 h-16 mx-auto mb-4 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
//           <p className="text-gray-600">{content[language].messages.loading}</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen p-4 md:p-6 bg-gradient-to-b from-gray-50 to-gray-100">
//       {/* Header */}
//       <div className="mb-8">
//         <div className="flex flex-col md:flex-row md:items-center justify-between mb-6">
//           <div>
//             <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
//               {content[language].pageTitle}
//             </h1>
//             <p className="text-gray-600">
//               {content[language].pageSubtitle}
//             </p>
//           </div>
          
//           {/* Language Toggle */}
//           <div className="mt-4 md:mt-0">
//             <div className="inline-flex rounded-lg border border-gray-300 p-1">
//               <button
//                 onClick={() => setLanguage('english')}
//                 className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
//                   language === 'english'
//                     ? 'bg-blue-600 text-white'
//                     : 'text-gray-700 hover:bg-gray-100'
//                 }`}
//               >
//                 English
//               </button>
//               <button
//                 onClick={() => setLanguage('marathi')}
//                 className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
//                   language === 'marathi'
//                     ? 'bg-blue-600 text-white'
//                     : 'text-gray-700 hover:bg-gray-100'
//                 }`}
//               >
//                 मराठी
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Property Information Card */}
//         <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-gray-200">
//           <div className="flex items-center mb-4">
//             <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center mr-4">
//               <FiHome size={24} className="text-blue-600" />
//             </div>
//             <div>
//               <h2 className="text-xl font-bold text-gray-800">
//                 {content[language].propertyInfo}
//               </h2>
//               <p className="text-gray-600 text-sm">
//                 {content[language].info.readOnly}
//               </p>
//             </div>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-500 mb-1">
//                 {language === 'english' ? 'Property ID' : 'मालमत्ता आयडी'}
//               </label>
//               <div className="text-lg font-semibold text-gray-800">
//                 {propertyData.sequenceNumber}
//               </div>
//             </div>
            
//             <div>
//               <label className="block text-sm font-medium text-gray-500 mb-1">
//                 {language === 'english' ? 'Owner Name' : 'मालकाचे नाव'}
//               </label>
//               <div className="text-lg font-semibold text-gray-800">
//                 {propertyData.ownerName}
//               </div>
//             </div>
            
//             <div>
//               <label className="block text-sm font-medium text-gray-500 mb-1">
//                 {language === 'english' ? 'New Property No.' : 'नवीन मालमत्ता क्रमांक'}
//               </label>
//               <div className="text-lg font-semibold text-gray-800">
//                 {propertyData.newPropertyNumber}
//               </div>
//             </div>
            
//             <div>
//               <label className="block text-sm font-medium text-gray-500 mb-1">
//                 {language === 'english' ? 'Old Property No.' : 'जुनी मालमत्ता क्रमांक'}
//               </label>
//               <div className="text-lg font-semibold text-gray-800">
//                 {propertyData.oldPropertyNumber}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
//         {/* Left Column - Year Selection and Actions */}
//         <div>
//           {/* Year Selection Card */}
//           <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
//             <div className="flex items-center mb-4">
//               <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center mr-4">
//                 <FiCalendar size={24} className="text-green-600" />
//               </div>
//               <div>
//                 <h2 className="text-xl font-bold text-gray-800">
//                   {content[language].assessmentYear}
//                 </h2>
//                 <p className="text-gray-600 text-sm">
//                   {content[language].selectYear}
//                 </p>
//               </div>
//             </div>

//             {/* Year Dropdown */}
//             <div className="mb-6">
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 {content[language].assessmentYear}
//               </label>
//               <div className="relative">
//                 <select
//                   value={selectedYear}
//                   onChange={(e) => handleYearChange(e.target.value)}
//                   className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white"
//                 >
//                   {assessmentYears.map((year) => (
//                     <option key={year} value={year}>
//                       {year} {year === getCurrentYear() ? `(${content[language].currentYear})` : ''}
//                     </option>
//                   ))}
//                 </select>
//                 <div className="absolute right-3 top-3 pointer-events-none">
//                   <MdArrowDropDown size={24} className="text-gray-400" />
//                 </div>
//               </div>
              
//               {/* Current Year Status */}
//               <div className="mt-4 p-3 rounded-lg bg-blue-50 border border-blue-200">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <p className="text-sm font-medium text-gray-700">
//                       {content[language].currentYear}: {getCurrentYear()}
//                     </p>
//                     <p className={`text-xs ${sampleTaxHistory[getCurrentYear()]?.[0]?.status === 'calculated' ? 'text-green-600' : 'text-red-600'}`}>
//                       {sampleTaxHistory[getCurrentYear()]?.[0]?.status === 'calculated' 
//                         ? content[language].taxCalculated
//                         : content[language].currentYearNotCalculated}
//                     </p>
//                   </div>
//                   {sampleTaxHistory[getCurrentYear()]?.[0]?.status !== 'calculated' && (
//                     <button
//                       onClick={handleCalculateCurrentYear}
//                       className="px-3 py-1 bg-blue-600 text-white text-xs font-medium rounded-lg hover:bg-blue-700 transition-colors"
//                     >
//                       <FiPlus size={12} className="inline mr-1" />
//                       {language === 'english' ? 'Calculate' : 'मोजा'}
//                     </button>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Action Buttons */}
//             <div className="space-y-3">
//               <button
//                 onClick={handleBack}
//                 className="w-full inline-flex items-center justify-center px-4 py-3 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors duration-200"
//               >
//                 <FiChevronLeft className="mr-2" />
//                 {content[language].buttons.back}
//               </button>

//               {selectedYear === getCurrentYear() && 
//                sampleTaxHistory[getCurrentYear()]?.[0]?.status !== 'calculated' && (
//                 <button
//                   onClick={handleCalculateCurrentYear}
//                   className="w-full inline-flex items-center justify-center px-4 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white font-medium rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200"
//                 >
//                   <FiPlus className="mr-2" />
//                   {content[language].buttons.calculateTax}
//                 </button>
//               )}

//               <button className="w-full inline-flex items-center justify-center px-4 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors duration-200">
//                 <FiRefreshCw className="mr-2" />
//                 {content[language].buttons.refresh}
//               </button>
//             </div>
//           </div>

//           {/* Stats Card */}
//           <div className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-xl shadow-lg p-6 text-white">
//             <div className="flex items-center mb-4">
//               <MdHistory size={24} className="mr-3" />
//               <h3 className="font-bold">
//                 {language === 'english' ? 'Tax Summary' : 'कर सारांश'}
//               </h3>
//             </div>
            
//             <div className="space-y-3">
//               <div className="flex justify-between items-center">
//                 <span className="text-sm opacity-90">{language === 'english' ? 'Total Years' : 'एकूण वर्षे'}</span>
//                 <span className="font-bold">{Object.keys(sampleTaxHistory).length}</span>
//               </div>
              
//               <div className="flex justify-between items-center">
//                 <span className="text-sm opacity-90">{language === 'english' ? 'Calculated Tax' : 'गणित केलेला कर'}</span>
//                 <span className="font-bold text-green-300">
//                   {Object.values(sampleTaxHistory).filter(year => year[0]?.status === 'calculated').length}
//                 </span>
//               </div>
              
//               <div className="flex justify-between items-center">
//                 <span className="text-sm opacity-90">{language === 'english' ? 'Pending Calculation' : 'प्रलंबित गणना'}</span>
//                 <span className="font-bold text-yellow-300">
//                   {Object.values(sampleTaxHistory).filter(year => year[0]?.status === 'not-calculated').length}
//                 </span>
//               </div>
              
//               <div className="flex justify-between items-center">
//                 <span className="text-sm opacity-90">{language === 'english' ? 'Total Tax Collected' : 'एकूण एकत्रित कर'}</span>
//                 <span className="font-bold">
//                   {formatCurrency(
//                     Object.values(sampleTaxHistory)
//                       .filter(year => year[0]?.status === 'calculated')
//                       .reduce((sum, year) => sum + (year[0]?.totalTax || 0), 0)
//                   )}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Right Column - Tax History Table */}
//         <div className="lg:col-span-3">
//           <div className="bg-white rounded-xl shadow-lg overflow-hidden">
//             {/* Table Header */}
//             <div className="p-6 border-b border-gray-200">
//               <div className="flex items-center justify-between">
//                 <div className="flex items-center">
//                   <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center mr-4">
//                     <MdReceiptLong size={24} className="text-purple-600" />
//                   </div>
//                   <div>
//                     <h2 className="text-xl font-bold text-gray-800">
//                       {content[language].taxHistory}
//                     </h2>
//                     <p className="text-gray-600 text-sm">
//                       {language === 'english' 
//                         ? `Showing tax records for assessment year: ${selectedYear}`
//                         : `मूल्यांकन वर्षासाठी कर नोंदी दर्शवित आहे: ${selectedYear}`}
//                     </p>
//                   </div>
//                 </div>
                
//                 <div className="text-sm text-gray-600">
//                   {language === 'english' ? 'Records:' : 'नोंदी:'} {currentTaxHistory.length}
//                 </div>
//               </div>
//             </div>

//             {/* Tax History Table */}
//             {currentTaxHistory.length > 0 ? (
//               <div className="overflow-x-auto">
//                 <table className="min-w-full divide-y divide-gray-200">
//                   <thead className="bg-gray-50">
//                     <tr>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         {content[language].tableHeaders.serial}
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         {content[language].tableHeaders.assessmentYear}
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         {content[language].tableHeaders.totalTax}
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         {content[language].tableHeaders.status}
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         {content[language].tableHeaders.actions}
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {currentTaxHistory.map((record, index) => (
//                       <tr key={record.id} className="hover:bg-gray-50 transition-colors duration-150">
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                           {index + 1}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium">
//                           <div className="flex items-center">
//                             <FiCalendar className="mr-2 text-gray-400" />
//                             {record.year}
//                           </div>
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900">
//                           {formatCurrency(record.totalTax)}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap">
//                           <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
//                             record.status === 'calculated'
//                               ? 'bg-green-100 text-green-800'
//                               : 'bg-red-100 text-red-800'
//                           }`}>
//                             {record.status === 'calculated' ? (
//                               <>
//                                 <FiCheckCircle className="mr-1" size={12} />
//                                 {content[language].status.calculated}
//                               </>
//                             ) : (
//                               <>
//                                 <FiXCircle className="mr-1" size={12} />
//                                 {content[language].status.notCalculated}
//                               </>
//                             )}
//                           </span>
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                           <div className="flex space-x-2">
//                             {/* View Button - Only show if tax is calculated */}
//                             {record.status === 'calculated' && (
//                               <button
//                                 onClick={() => handleView(record)}
//                                 className="inline-flex items-center px-3 py-1.5 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-colors duration-200"
//                                 title={content[language].buttons.view}
//                               >
//                                 <FiEye size={16} />
//                                 <span className="ml-1 hidden sm:inline">{content[language].buttons.view}</span>
//                               </button>
//                             )}
                            
//                             {/* Edit Button - Only show if tax is NOT calculated */}
//                             {record.status === 'not-calculated' && (
//                               <button
//                                 onClick={() => handleEdit(record)}
//                                 className="inline-flex items-center px-3 py-1.5 bg-green-50 text-green-600 rounded-lg hover:bg-green-100 transition-colors duration-200"
//                                 title={content[language].buttons.edit}
//                               >
//                                 <FiEdit size={16} />
//                                 <span className="ml-1 hidden sm:inline">{content[language].buttons.edit}</span>
//                               </button>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             ) : (
//               <div className="p-12 text-center">
//                 <div className="w-24 h-24 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
//                   <FiFileText size={48} className="text-gray-400" />
//                 </div>
//                 <h3 className="text-xl font-semibold text-gray-800 mb-2">
//                   {content[language].messages.noTaxForYear}
//                 </h3>
//                 <p className="text-gray-600 mb-6">
//                   {language === 'english' 
//                     ? 'No tax records found for the selected assessment year.'
//                     : 'निवडलेल्या मूल्यांकन वर्षासाठी कर नोंदी आढळल्या नाहीत.'}
//                 </p>
//                 {selectedYear === getCurrentYear() && (
//                   <button
//                     onClick={handleCalculateCurrentYear}
//                     className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-medium rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200"
//                   >
//                     <FiPlus className="mr-2" />
//                     {content[language].buttons.calculateTax}
//                   </button>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Year Navigation */}
//           <div className="mt-6 bg-white rounded-xl shadow-lg p-6">
//             <h3 className="text-lg font-bold text-gray-800 mb-4">
//               {language === 'english' ? 'Browse Other Years' : 'इतर वर्षे पहा'}
//             </h3>
//             <div className="flex flex-wrap gap-2">
//               {assessmentYears.map((year) => (
//                 <button
//                   key={year}
//                   onClick={() => handleYearChange(year)}
//                   className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${
//                     selectedYear === year
//                       ? 'bg-blue-600 text-white'
//                       : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
//                   }`}
//                 >
//                   {year}
//                   {year === getCurrentYear() && (
//                     <span className="ml-1 text-xs">({language === 'english' ? 'Current' : 'चालू'})</span>
//                   )}
//                 </button>
//               ))}
//             </div>
//           </div>

//           {/* Important Notes */}
//           <div className="mt-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl shadow-lg p-6 border border-blue-200">
//             <h3 className="font-bold text-gray-800 mb-3 flex items-center">
//               <FiFileText className="mr-2 text-blue-600" />
//               {language === 'english' ? 'Important Notes' : 'महत्वाच्या सूचना'}
//             </h3>
//             <ul className="space-y-2 text-sm text-gray-700">
//               <li className="flex items-start">
//                 <span className="text-blue-600 mr-2">•</span>
//                 {language === 'english' 
//                   ? 'View button is only available for years with calculated tax'
//                   : 'व्ह्यू बटण केवळ गणित केलेल्या कराच्या वर्षांसाठी उपलब्ध आहे'}
//               </li>
//               <li className="flex items-start">
//                 <span className="text-blue-600 mr-2">•</span>
//                 {language === 'english' 
//                   ? 'Edit button is only available for years without calculated tax'
//                   : 'एडिट बटण केवळ गणित न केलेल्या कराच्या वर्षांसाठी उपलब्ध आहे'}
//               </li>
//               <li className="flex items-start">
//                 <span className="text-blue-600 mr-2">•</span>
//                 {language === 'english' 
//                   ? 'Once tax is calculated, it cannot be edited (view only)'
//                   : 'एकदा कर गणित केल्यानंतर, तो सुधारता येत नाही (केवळ पहाण्यासाठी)'}
//               </li>
//               <li className="flex items-start">
//                 <span className="text-blue-600 mr-2">•</span>
//                 {language === 'english' 
//                   ? 'Click on year buttons above to view tax records for other years'
//                   : 'इतर वर्षांच्या कर नोंदी पाहण्यासाठी वरील वर्ष बटणांवर क्लिक करा'}
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>

//       {/* Footer Note */}
//       <div className="mt-8 text-center text-sm text-gray-500">
//         <p>
//           {language === 'english' 
//             ? '© 2024 Government of Maharashtra. All rights reserved.'
//             : '© २०२४ महाराष्ट्र शासन. सर्व हक्क राखीव.'}
//         </p>
//         <p className="mt-1">
//           {language === 'english'
//             ? 'Property Tax History Management System'
//             : 'मालमत्ता कर इतिहास व्यवस्थापन प्रणाली'}
//         </p>
//       </div>
//     </div>
//   );
// };

// export default TaxHistory;





import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { 
  FiCalendar,
  FiChevronLeft,
  FiEye,
  FiEdit,
  FiPlus,
  FiCheckCircle,
  FiXCircle,
  FiRefreshCw,
  FiFileText,
  FiHome,
  FiUser,
  FiDollarSign,
  FiTrendingUp,
  FiDownload,
  FiPrinter,
  FiClock,
  FiAlertCircle
} from 'react-icons/fi';
import {
  MdHistory,
  MdAttachMoney,
  MdAssessment,
  MdArrowDropDown,
  MdReceiptLong,
  MdVerified,
  MdPending,
  MdWarning,
  MdInfo,
  MdArrowForward
} from 'react-icons/md';

const TaxHistory = () => {
  const { propertyId } = useParams();
  const navigate = useNavigate();
  const [language, setLanguage] = useState('english');
  const [selectedYear, setSelectedYear] = useState('');
  const [loading, setLoading] = useState(true);
  const [propertyData, setPropertyData] = useState(null);
  const [taxHistory, setTaxHistory] = useState({});
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [selectedReceipt, setSelectedReceipt] = useState(null);

  // Government of Maharashtra color scheme
  const colors = {
    primary: '#003366',
    secondary: '#FF9933',
    accent: '#138808',
    lightBlue: '#E6F0FF',
    lightOrange: '#FFF0E6',
    lightGreen: '#E6FFE6',
    white: '#FFFFFF',
    dark: '#1E293B',
    gray: '#64748B'
  };

  // Generate assessment years (current year + previous 5 years)
  const generateAssessmentYears = () => {
    const years = [];
    const currentYear = new Date().getFullYear();
    
    // Current financial year (e.g., 2024-25)
    const currentFinancialYear = `${currentYear}-${(currentYear + 1).toString().slice(2)}`;
    
    // Add previous 5 years
    for (let i = 0; i <= 5; i++) {
      const year = currentYear - i;
      const financialYear = `${year}-${(year + 1).toString().slice(2)}`;
      years.push(financialYear);
    }
    
    return years.reverse(); // Sort from oldest to newest
  };

  const assessmentYears = generateAssessmentYears();

  // Language content
  const content = {
    english: {
      pageTitle: 'Property Tax History',
      pageSubtitle: 'Year-wise tax assessment and payment records',
      propertyInfo: 'Property Information',
      assessmentYear: 'Assessment Year',
      selectYear: 'Select Assessment Year',
      currentYear: 'Current Year',
      taxHistory: 'Tax History',
      tableHeaders: {
        serial: 'Sr No',
        assessmentYear: 'Assessment Year',
        totalTax: 'Total Tax (₹)',
        status: 'Status',
        actions: 'Actions'
      },
      status: {
        calculated: 'Calculated',
        notCalculated: 'Not Calculated',
        paid: 'Paid',
        pending: 'Pending',
        overdue: 'Overdue'
      },
      buttons: {
        back: 'Back to Property List',
        calculateTax: 'Calculate Tax',
        refresh: 'Refresh',
        view: 'View Receipt',
        edit: 'Calculate/Edit',
        download: 'Download',
        print: 'Print',
        viewDetails: 'View Details',
        calculateNow: 'Calculate Now'
      },
      messages: {
        loading: 'Loading tax history...',
        noTaxForYear: 'No tax records found for selected year',
        currentYearNotCalculated: 'Current year tax not calculated yet',
        clickToCalculate: 'Click to calculate tax for current year',
        taxCalculated: 'Tax already calculated for this year',
        selectYearPrompt: 'Please select an assessment year',
        dataLoaded: 'Tax history data loaded successfully',
        calculatingTax: 'Calculating tax for selected year...'
      },
      info: {
        readOnly: 'Read-only information',
        taxExists: 'Tax exists and calculated',
        taxNotExists: 'Tax not calculated yet',
        financialYear: 'Financial Year',
        assessmentPeriod: 'Assessment Period',
        dueDate: 'Due Date',
        paymentStatus: 'Payment Status'
      },
      labels: {
        propertyId: 'Property ID',
        ownerName: 'Owner Name',
        propertyNumber: 'Property Number',
        address: 'Address',
        propertyType: 'Property Type',
        registrationDate: 'Registration Date'
      },
      receipt: {
        title: 'Tax Receipt',
        number: 'Receipt Number',
        date: 'Payment Date',
        amount: 'Tax Amount',
        status: 'Payment Status',
        download: 'Download Receipt',
        print: 'Print Receipt'
      }
    },
    marathi: {
      pageTitle: 'मालमत्ता कर इतिहास',
      pageSubtitle: 'वर्षानुसार कर मूल्यांकन आणि पेमेंट नोंदी',
      propertyInfo: 'मालमत्ता माहिती',
      assessmentYear: 'मूल्यांकन वर्ष',
      selectYear: 'मूल्यांकन वर्ष निवडा',
      currentYear: 'चालू वर्ष',
      taxHistory: 'कर इतिहास',
      tableHeaders: {
        serial: 'अनुक्रमांक',
        assessmentYear: 'मूल्यांकन वर्ष',
        totalTax: 'एकूण कर (₹)',
        status: 'स्थिती',
        actions: 'क्रिया'
      },
      status: {
        calculated: 'गणित केले',
        notCalculated: 'गणित केले नाही',
        paid: 'पेड',
        pending: 'प्रलंबित',
        overdue: 'ओव्हरड्यू'
      },
      buttons: {
        back: 'मालमत्ता यादीकडे परत',
        calculateTax: 'कर मोजा',
        refresh: 'रिफ्रेश',
        view: 'पावती पहा',
        edit: 'गणना/सुधारा',
        download: 'डाउनलोड',
        print: 'प्रिंट',
        viewDetails: 'तपशील पहा',
        calculateNow: 'आत्ताच मोजा'
      },
      messages: {
        loading: 'कर इतिहास लोड करत आहे...',
        noTaxForYear: 'निवडलेल्या वर्षासाठी कर नोंदी आढळल्या नाहीत',
        currentYearNotCalculated: 'चालू वर्षाचा कर अद्याप मोजला गेला नाही',
        clickToCalculate: 'चालू वर्षासाठी कर मोजण्यासाठी क्लिक करा',
        taxCalculated: 'या वर्षासाठी कर आधीच मोजला गेला आहे',
        selectYearPrompt: 'कृपया मूल्यांकन वर्ष निवडा',
        dataLoaded: 'कर इतिहास डेटा यशस्वीरित्या लोड केला',
        calculatingTax: 'निवडलेल्या वर्षासाठी कर मोजत आहे...'
      },
      info: {
        readOnly: 'केवळ वाचनासाठी माहिती',
        taxExists: 'कर अस्तित्वात आहे आणि गणित केला आहे',
        taxNotExists: 'कर अद्याप गणित केला गेला नाही',
        financialYear: 'आर्थिक वर्ष',
        assessmentPeriod: 'मूल्यांकन कालावधी',
        dueDate: 'देय तारीख',
        paymentStatus: 'पेमेंट स्थिती'
      },
      labels: {
        propertyId: 'मालमत्ता आयडी',
        ownerName: 'मालकाचे नाव',
        propertyNumber: 'मालमत्ता क्रमांक',
        address: 'पत्ता',
        propertyType: 'मालमत्ता प्रकार',
        registrationDate: 'नोंदणी तारीख'
      },
      receipt: {
        title: 'कर पावती',
        number: 'पावती क्रमांक',
        date: 'पेमेंट तारीख',
        amount: 'कर रक्कम',
        status: 'पेमेंट स्थिती',
        download: 'पावती डाउनलोड करा',
        print: 'पावती प्रिंट करा'
      }
    }
  };

  // Format currency in Indian Rupees
  const formatCurrency = (amount) => {
    if (!amount || amount === 0) return '₹0';
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  // Get current financial year
  const getCurrentYear = () => {
    const currentYear = new Date().getFullYear();
    const nextYear = currentYear + 1;
    return `${currentYear}-${nextYear.toString().slice(2)}`;
  };

  // Generate receipt number
  const generateReceiptNumber = (year) => {
    const randomNum = Math.floor(1000 + Math.random() * 9000);
    return `RCPT-${year.split('-')[0]}-${randomNum}`;
  };

  // Generate due date based on assessment year
  const generateDueDate = (assessmentYear) => {
    const year = assessmentYear.split('-')[1];
    return `31 March 20${year}`;
  };

  // Load property data and tax history
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      
      try {
        // Load property data from localStorage
        const properties = JSON.parse(localStorage.getItem('propertyList') || '[]');
        const property = properties.find(p => p.id === propertyId) || 
                         properties.find(p => p.sequenceNumber === propertyId) ||
                         properties[0];
        
        if (property) {
          setPropertyData(property);
          
          // Generate tax history for all years
          const history = {};
          assessmentYears.forEach(year => {
            const isCalculated = Math.random() > 0.3; // 70% chance of being calculated
            const totalTax = isCalculated ? Math.floor(25000 + Math.random() * 25000) : 0;
            
            history[year] = {
              id: `${propertyId}-${year}`,
              year,
              totalTax,
              status: isCalculated ? 'calculated' : 'not-calculated',
              paymentStatus: isCalculated ? (Math.random() > 0.5 ? 'paid' : 'pending') : null,
              receiptNumber: isCalculated ? generateReceiptNumber(year) : null,
              paymentDate: isCalculated ? `${Math.floor(Math.random() * 28) + 1} March 20${year.split('-')[1]}` : null,
              dueDate: generateDueDate(year),
              lastUpdated: new Date().toISOString()
            };
          });
          
          setTaxHistory(history);
          
          // Set current year as default selection
          setSelectedYear(getCurrentYear());
        }
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 800);
      }
    };

    loadData();
  }, [propertyId]);

  // Handle year change
  const handleYearChange = (year) => {
    setSelectedYear(year);
  };

  // Handle view action - Show receipt modal
  const handleView = (taxRecord) => {
    setSelectedReceipt(taxRecord);
    setShowReceiptModal(true);
  };

  // Handle edit/calculate action
  const handleEdit = (taxRecord) => {
    // Show loading state
    const updatedHistory = { ...taxHistory };
    updatedHistory[taxRecord.year] = {
      ...taxRecord,
      status: 'calculating'
    };
    setTaxHistory(updatedHistory);
    
    // Simulate calculation process
    setTimeout(() => {
      const calculatedTax = Math.floor(25000 + Math.random() * 25000);
      const updatedRecord = {
        ...taxRecord,
        totalTax: calculatedTax,
        status: 'calculated',
        receiptNumber: generateReceiptNumber(taxRecord.year),
        paymentDate: new Date().toLocaleDateString('en-IN'),
        paymentStatus: 'pending',
        lastUpdated: new Date().toISOString()
      };
      
      updatedHistory[taxRecord.year] = updatedRecord;
      setTaxHistory(updatedHistory);
      
      // Navigate to calculate tax page (in real app)
      // navigate(`/calculate-tax/${propertyId}?year=${taxRecord.year}`);
    }, 1500);
  };

  // Handle calculate current year tax
  const handleCalculateCurrentYear = () => {
    const currentYear = getCurrentYear();
    const currentRecord = taxHistory[currentYear];
    
    if (currentRecord && currentRecord.status === 'not-calculated') {
      handleEdit(currentRecord);
    } else {
      navigate(`/calculate-tax/${propertyId}?year=${currentYear}`);
    }
  };

  // Handle back to property list
  const handleBack = () => {
    navigate('/property-list');
  };

  // Handle refresh
  const handleRefresh = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  // Handle download receipt
  const handleDownloadReceipt = (receipt) => {
    alert(`${language === 'english' ? 'Downloading receipt:' : 'पावती डाउनलोड करत आहे:'} ${receipt.receiptNumber}`);
    // In real app, this would trigger PDF download
  };

  // Handle print receipt
  const handlePrintReceipt = (receipt) => {
    alert(`${language === 'english' ? 'Printing receipt:' : 'पावती प्रिंट करत आहे:'} ${receipt.receiptNumber}`);
    // In real app, this would open print dialog
  };

  // Get status badge styling
  const getStatusBadge = (status, paymentStatus = null) => {
    switch(status) {
      case 'calculated':
        return paymentStatus === 'paid' 
          ? 'bg-green-100 text-green-800 border-green-200'
          : paymentStatus === 'pending'
          ? 'bg-yellow-100 text-yellow-800 border-yellow-200'
          : 'bg-blue-100 text-blue-800 border-blue-200';
      case 'calculating':
        return 'bg-purple-100 text-purple-800 border-purple-200';
      case 'not-calculated':
      default:
        return 'bg-red-100 text-red-800 border-red-200';
    }
  };

  // Get status icon
  const getStatusIcon = (status, paymentStatus = null) => {
    switch(status) {
      case 'calculated':
        return paymentStatus === 'paid' 
          ? <FiCheckCircle className="text-green-600" />
          : paymentStatus === 'pending'
          ? <FiClock className="text-yellow-600" />
          : <MdVerified className="text-blue-600" />;
      case 'calculating':
        return <FiRefreshCw className="animate-spin text-purple-600" />;
      case 'not-calculated':
      default:
        return <FiXCircle className="text-red-600" />;
    }
  };

  // Get current tax history
  const currentTaxHistory = selectedYear ? taxHistory[selectedYear] ? [taxHistory[selectedYear]] : [] : [];

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-blue-50 to-white">
        <div className="text-center">
          <div className="w-20 h-20 mx-auto mb-6 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">
            {content[language].messages.loading}
          </h3>
          <p className="text-gray-600 max-w-md">
            {language === 'english' 
              ? 'Loading property tax history and assessment data...'
              : 'मालमत्ता कर इतिहास आणि मूल्यांकन डेटा लोड करत आहे...'}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-4 md:p-6 bg-gradient-to-b from-gray-50 to-gray-100">
      {/* Receipt Modal */}
      {showReceiptModal && selectedReceipt && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 transform transition-all duration-300 scale-100 animate-fadeIn">
            <div className="flex justify-between items-center mb-6">
              <div>
                <h3 className="text-2xl font-bold text-gray-800">
                  {content[language].receipt.title}
                </h3>
                <p className="text-sm text-gray-600">
                  {content[language].labels.propertyId}: {propertyData?.sequenceNumber}
                </p>
              </div>
              <button
                onClick={() => setShowReceiptModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <FiXCircle size={24} />
              </button>
            </div>

            <div className="space-y-4 mb-8">
              <div className="flex justify-between items-center">
                <span className="text-gray-600">{content[language].receipt.number}</span>
                <span className="font-mono font-bold text-blue-600">{selectedReceipt.receiptNumber}</span>
              </div>
              
              <div className="flex justify-between items-center">
                <span className="text-gray-600">{content[language].assessmentYear}</span>
                <span className="font-semibold">{selectedReceipt.year}</span>
              </div>
              
              <div className="flex justify-between items-center">
                <span className="text-gray-600">{content[language].receipt.date}</span>
                <span className="font-semibold">{selectedReceipt.paymentDate}</span>
              </div>
              
              <div className="flex justify-between items-center">
                <span className="text-gray-600">{content[language].receipt.amount}</span>
                <span className="text-2xl font-bold text-green-600">
                  {formatCurrency(selectedReceipt.totalTax)}
                </span>
              </div>
              
              <div className="flex justify-between items-center">
                <span className="text-gray-600">{content[language].receipt.status}</span>
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusBadge(selectedReceipt.status, selectedReceipt.paymentStatus)}`}>
                  {selectedReceipt.paymentStatus || content[language].status.calculated}
                </span>
              </div>
            </div>

            <div className="flex space-x-4">
              <button
                onClick={() => handleDownloadReceipt(selectedReceipt)}
                className="flex-1 inline-flex items-center justify-center px-4 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
              >
                <FiDownload className="mr-2" />
                {content[language].receipt.download}
              </button>
              <button
                onClick={() => handlePrintReceipt(selectedReceipt)}
                className="flex-1 inline-flex items-center justify-center px-4 py-3 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors"
              >
                <FiPrinter className="mr-2" />
                {content[language].receipt.print}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="mb-8">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
              {content[language].pageTitle}
            </h1>
            <p className="text-gray-600">
              {content[language].pageSubtitle}
            </p>
          </div>
          
          {/* Language Toggle */}
          <div className="mt-4 md:mt-0">
            <div className="inline-flex rounded-lg border border-gray-300 p-1 bg-white shadow-sm">
              <button
                onClick={() => setLanguage('english')}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
                  language === 'english'
                    ? 'bg-blue-600 text-white shadow-sm'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                English
              </button>
              <button
                onClick={() => setLanguage('marathi')}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
                  language === 'marathi'
                    ? 'bg-blue-600 text-white shadow-sm'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                मराठी
              </button>
            </div>
          </div>
        </div>

        {/* Property Information Card */}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-gray-200 hover:shadow-xl transition-shadow duration-300">
          <div className="flex items-center mb-4">
            <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center mr-4">
              <FiHome size={24} className="text-blue-600" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-800">
                {content[language].propertyInfo}
              </h2>
              <p className="text-gray-600 text-sm">
                {content[language].info.readOnly}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-500 mb-1">
                {content[language].labels.propertyId}
              </label>
              <div className="text-lg font-semibold text-gray-800 font-mono">
                {propertyData?.sequenceNumber || 'N/A'}
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-500 mb-1">
                {content[language].labels.ownerName}
              </label>
              <div className="text-lg font-semibold text-gray-800">
                {propertyData?.ownerName || 'N/A'}
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-500 mb-1">
                {content[language].labels.propertyNumber}
              </label>
              <div className="text-lg font-semibold text-gray-800">
                {propertyData?.newPropertyNumber || propertyData?.oldPropertyNumber || 'N/A'}
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-500 mb-1">
                {content[language].labels.propertyType}
              </label>
              <div className="text-lg font-semibold text-gray-800">
                {propertyData?.buildingType || propertyData?.propertyType || 'N/A'}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Left Column - Year Selection and Actions */}
        <div className="space-y-6">
          {/* Year Selection Card */}
          <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center mr-4">
                <FiCalendar size={24} className="text-green-600" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-800">
                  {content[language].assessmentYear}
                </h2>
                <p className="text-gray-600 text-sm">
                  {content[language].selectYear}
                </p>
              </div>
            </div>

            {/* Year Selection */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {content[language].assessmentYear}
              </label>
              <div className="grid grid-cols-2 gap-2 mb-4">
                {assessmentYears.map((year) => (
                  <button
                    key={year}
                    onClick={() => handleYearChange(year)}
                    className={`p-3 rounded-lg border transition-all duration-200 text-sm font-medium ${
                      selectedYear === year
                        ? 'bg-blue-600 text-white border-blue-600 shadow-sm'
                        : 'bg-gray-50 text-gray-700 border-gray-300 hover:bg-gray-100 hover:border-gray-400'
                    }`}
                  >
                    {year}
                    {year === getCurrentYear() && (
                      <span className="text-xs ml-1 opacity-75">
                        ({content[language].currentYear})
                      </span>
                    )}
                  </button>
                ))}
              </div>

              {/* Selected Year Status */}
              {selectedYear && (
                <div className={`p-4 rounded-lg border ${
                  taxHistory[selectedYear]?.status === 'calculated'
                    ? 'bg-green-50 border-green-200'
                    : taxHistory[selectedYear]?.status === 'calculating'
                    ? 'bg-purple-50 border-purple-200'
                    : 'bg-red-50 border-red-200'
                }`}>
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm font-medium text-gray-700">
                        {content[language].info.financialYear}: {selectedYear}
                      </p>
                      <p className={`text-xs font-medium ${
                        taxHistory[selectedYear]?.status === 'calculated'
                          ? 'text-green-600'
                          : taxHistory[selectedYear]?.status === 'calculating'
                          ? 'text-purple-600'
                          : 'text-red-600'
                      }`}>
                        {taxHistory[selectedYear]?.status === 'calculated'
                          ? content[language].info.taxExists
                          : taxHistory[selectedYear]?.status === 'calculating'
                          ? content[language].messages.calculatingTax
                          : content[language].info.taxNotExists}
                      </p>
                    </div>
                    {taxHistory[selectedYear] && (
                      <div className="flex items-center">
                        {getStatusIcon(taxHistory[selectedYear].status, taxHistory[selectedYear].paymentStatus)}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Quick Actions */}
            <div className="space-y-3">
              <button
                onClick={handleBack}
                className="w-full inline-flex items-center justify-center px-4 py-3 bg-gray-100 text-gray-700 font-medium rounded-lg border border-gray-300 hover:bg-gray-200 hover:border-gray-400 transition-all duration-200"
              >
                <FiChevronLeft className="mr-2" />
                {content[language].buttons.back}
              </button>

              {selectedYear && taxHistory[selectedYear]?.status === 'not-calculated' && (
                <button
                  onClick={() => handleEdit(taxHistory[selectedYear])}
                  className="w-full inline-flex items-center justify-center px-4 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white font-medium rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200"
                >
                  <FiPlus className="mr-2" />
                  {content[language].buttons.calculateNow}
                </button>
              )}

              <button
                onClick={handleRefresh}
                className="w-full inline-flex items-center justify-center px-4 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
              >
                <FiRefreshCw className="mr-2" />
                {content[language].buttons.refresh}
              </button>
            </div>
          </div>

          {/* Quick Stats Card */}
          <div className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-xl shadow-lg p-6 text-white">
            <div className="flex items-center mb-4">
              <MdHistory size={24} className="mr-3" />
              <h3 className="font-bold">
                {language === 'english' ? 'Tax Overview' : 'कर संक्षिप्त विहंगावलोकन'}
              </h3>
            </div>
            
            <div className="space-y-4">
              <div>
                <div className="flex justify-between items-center mb-1">
                  <span className="text-sm opacity-90">{language === 'english' ? 'Total Years Tracked' : 'एकूण ट्रॅक केलेली वर्षे'}</span>
                  <span className="font-bold">{assessmentYears.length}</span>
                </div>
                <div className="w-full bg-blue-700 rounded-full h-2">
                  <div className="bg-green-400 h-2 rounded-full" style={{ width: '100%' }}></div>
                </div>
              </div>
              
              <div>
                <div className="flex justify-between items-center mb-1">
                  <span className="text-sm opacity-90">{language === 'english' ? 'Tax Calculated' : 'गणित केलेला कर'}</span>
                  <span className="font-bold text-green-300">
                    {Object.values(taxHistory).filter(year => year.status === 'calculated').length}
                  </span>
                </div>
                <div className="w-full bg-blue-700 rounded-full h-2">
                  <div className="bg-green-400 h-2 rounded-full" 
                    style={{ width: `${(Object.values(taxHistory).filter(year => year.status === 'calculated').length / assessmentYears.length) * 100}%` }}>
                  </div>
                </div>
              </div>
              
              <div>
                <div className="flex justify-between items-center mb-1">
                  <span className="text-sm opacity-90">{language === 'english' ? 'Pending Calculation' : 'प्रलंबित गणना'}</span>
                  <span className="font-bold text-yellow-300">
                    {Object.values(taxHistory).filter(year => year.status === 'not-calculated').length}
                  </span>
                </div>
                <div className="w-full bg-blue-700 rounded-full h-2">
                  <div className="bg-yellow-400 h-2 rounded-full" 
                    style={{ width: `${(Object.values(taxHistory).filter(year => year.status === 'not-calculated').length / assessmentYears.length) * 100}%` }}>
                  </div>
                </div>
              </div>
              
              <div className="pt-4 border-t border-blue-700">
                <div className="flex justify-between items-center">
                  <span className="text-sm opacity-90">{language === 'english' ? 'Total Tax Liability' : 'एकूण कर दायित्व'}</span>
                  <span className="font-bold text-xl">
                    {formatCurrency(
                      Object.values(taxHistory)
                        .filter(year => year.status === 'calculated')
                        .reduce((sum, year) => sum + (year.totalTax || 0), 0)
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Tax History Table */}
        <div className="lg:col-span-3">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
            {/* Table Header */}
            <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
              <div className="flex flex-col md:flex-row md:items-center justify-between">
                <div className="flex items-center mb-4 md:mb-0">
                  <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center mr-4">
                    <MdReceiptLong size={24} className="text-purple-600" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-gray-800">
                      {content[language].taxHistory}
                    </h2>
                    <p className="text-gray-600 text-sm">
                      {selectedYear 
                        ? (language === 'english' 
                            ? `Showing tax record for assessment year: ${selectedYear}`
                            : `मूल्यांकन वर्षासाठी कर नोंद दर्शवित आहे: ${selectedYear}`)
                        : content[language].messages.selectYearPrompt}
                    </p>
                  </div>
                </div>
                
                {selectedYear && (
                  <div className="flex items-center space-x-2">
                    <div className="text-sm text-gray-600 bg-gray-100 px-3 py-1 rounded-lg">
                      {language === 'english' ? 'Assessment Year:' : 'मूल्यांकन वर्ष:'} <span className="font-bold">{selectedYear}</span>
                    </div>
                    {taxHistory[selectedYear]?.dueDate && (
                      <div className="text-sm text-gray-600 bg-yellow-50 px-3 py-1 rounded-lg border border-yellow-200">
                        {language === 'english' ? 'Due:' : 'देय:'} {taxHistory[selectedYear].dueDate}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Tax History Table */}
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      {content[language].tableHeaders.serial}
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      {content[language].tableHeaders.assessmentYear}
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      {content[language].tableHeaders.totalTax}
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      {content[language].tableHeaders.status}
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      {content[language].tableHeaders.actions}
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {selectedYear && taxHistory[selectedYear] ? (
                    <tr key={taxHistory[selectedYear].id} className="hover:bg-gray-50 transition-colors duration-150">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900 bg-gray-100 w-8 h-8 flex items-center justify-center rounded-full">
                          1
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <FiCalendar className="mr-3 text-gray-400" />
                          <div>
                            <div className="text-sm font-bold text-gray-900">
                              {taxHistory[selectedYear].year}
                            </div>
                            <div className="text-xs text-gray-500">
                              {language === 'english' ? 'Assessment Period' : 'मूल्यांकन कालावधी'}: Apr 1 - Mar 31
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-2xl font-bold text-gray-900">
                          {formatCurrency(taxHistory[selectedYear].totalTax)}
                        </div>
                        {taxHistory[selectedYear].status === 'calculated' && (
                          <div className="text-xs text-gray-500">
                            {language === 'english' ? 'Tax liability' : 'कर दायित्व'}
                          </div>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <span className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium border ${getStatusBadge(taxHistory[selectedYear].status, taxHistory[selectedYear].paymentStatus)}`}>
                            {getStatusIcon(taxHistory[selectedYear].status, taxHistory[selectedYear].paymentStatus)}
                            <span className="ml-2">
                              {taxHistory[selectedYear].status === 'calculated' 
                                ? (taxHistory[selectedYear].paymentStatus 
                                    ? content[language].status[taxHistory[selectedYear].paymentStatus]
                                    : content[language].status.calculated)
                                : taxHistory[selectedYear].status === 'calculating'
                                ? content[language].messages.calculatingTax
                                : content[language].status.notCalculated}
                            </span>
                          </span>
                        </div>
                        {taxHistory[selectedYear].status === 'calculated' && taxHistory[selectedYear].dueDate && (
                          <div className="text-xs text-gray-500 mt-1">
                            {content[language].info.dueDate}: {taxHistory[selectedYear].dueDate}
                          </div>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex space-x-2">
                          {/* View Button - Show only if tax is calculated */}
                          {taxHistory[selectedYear].status === 'calculated' && (
                            <button
                              onClick={() => handleView(taxHistory[selectedYear])}
                              className="inline-flex items-center px-4 py-2 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-colors duration-200 shadow-sm"
                              title={content[language].buttons.view}
                            >
                              <FiEye className="mr-2" />
                              {content[language].buttons.view}
                            </button>
                          )}
                          
                          {/* Edit/Calculate Button - Show only if tax is NOT calculated or is calculating */}
                          {(taxHistory[selectedYear].status === 'not-calculated' || taxHistory[selectedYear].status === 'calculating') && (
                            <button
                              onClick={() => handleEdit(taxHistory[selectedYear])}
                              disabled={taxHistory[selectedYear].status === 'calculating'}
                              className={`inline-flex items-center px-4 py-2 rounded-lg transition-colors duration-200 shadow-sm ${
                                taxHistory[selectedYear].status === 'calculating'
                                  ? 'bg-purple-50 text-purple-600 cursor-not-allowed'
                                  : 'bg-green-50 text-green-600 hover:bg-green-100'
                              }`}
                              title={content[language].buttons.edit}
                            >
                              {taxHistory[selectedYear].status === 'calculating' ? (
                                <>
                                  <FiRefreshCw className="mr-2 animate-spin" />
                                  {language === 'english' ? 'Calculating...' : 'गणना करत आहे...'}
                                </>
                              ) : (
                                <>
                                  <FiEdit className="mr-2" />
                                  {content[language].buttons.edit}
                                </>
                              )}
                            </button>
                          )}
                          
                          {/* Additional details button for calculated tax */}
                          {taxHistory[selectedYear].status === 'calculated' && (
                            <button
                              onClick={() => {/* Navigate to detailed view */}}
                              className="inline-flex items-center px-3 py-2 bg-gray-50 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                              title={content[language].buttons.viewDetails}
                            >
                              <MdArrowForward />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan="5" className="px-6 py-12 text-center">
                        <div className="w-24 h-24 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
                          <FiCalendar size={48} className="text-gray-400" />
                        </div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">
                          {content[language].messages.selectYearPrompt}
                        </h3>
                        <p className="text-gray-600 mb-6 max-w-md mx-auto">
                          {language === 'english' 
                            ? 'Please select an assessment year from the left panel to view tax history.'
                            : 'कर इतिहास पाहण्यासाठी कृपया डाव्या पॅनेलमधून मूल्यांकन वर्ष निवडा.'}
                        </p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Table Footer */}
            {selectedYear && taxHistory[selectedYear] && (
              <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                <div className="flex flex-col md:flex-row md:items-center justify-between">
                  <div className="text-sm text-gray-600 mb-2 md:mb-0">
                    {language === 'english' 
                      ? `Showing tax record for assessment year ${selectedYear}`
                      : `मूल्यांकन वर्ष ${selectedYear} साठी कर नोंद दर्शवित आहे`}
                  </div>
                  <div className="flex items-center space-x-4">
                    {taxHistory[selectedYear].receiptNumber && (
                      <div className="text-sm font-mono text-gray-700 bg-white px-3 py-1 rounded border">
                        {language === 'english' ? 'Receipt:' : 'पावती:'} {taxHistory[selectedYear].receiptNumber}
                      </div>
                    )}
                    {taxHistory[selectedYear].lastUpdated && (
                      <div className="text-xs text-gray-500">
                        {language === 'english' ? 'Last updated:' : 'शेवटचे अद्यतन:'} {new Date(taxHistory[selectedYear].lastUpdated).toLocaleDateString()}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Year Navigation Card */}
          <div className="mt-6 bg-white rounded-xl shadow-lg p-6 border border-gray-200">
            <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
              <MdHistory className="mr-2 text-blue-600" />
              {language === 'english' ? 'Quick Year Navigation' : 'द्रुत वर्ष नेव्हिगेशन'}
            </h3>
            <div className="flex flex-wrap gap-2">
              {assessmentYears.map((year) => (
                <button
                  key={year}
                  onClick={() => handleYearChange(year)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 flex items-center ${
                    selectedYear === year
                      ? 'bg-blue-600 text-white shadow-md'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:shadow-sm'
                  }`}
                >
                  {year}
                  {year === getCurrentYear() && (
                    <span className="ml-2 text-xs px-1.5 py-0.5 bg-white bg-opacity-20 rounded">
                      {language === 'english' ? 'Current' : 'चालू'}
                    </span>
                  )}
                  {taxHistory[year]?.status === 'calculated' && (
                    <FiCheckCircle className={`ml-2 ${selectedYear === year ? 'text-white' : 'text-green-500'}`} size={14} />
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* Important Information Card */}
          <div className="mt-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl shadow-lg p-6 border border-blue-200">
            <h3 className="font-bold text-gray-800 mb-3 flex items-center">
              <MdInfo className="mr-2 text-blue-600" />
              {language === 'english' ? 'How Tax History Works' : 'कर इतिहास कसा कार्य करतो'}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-white rounded-lg p-4 border border-gray-200">
                <div className="flex items-center mb-2">
                  <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center mr-3">
                    <FiEye className="text-blue-600" size={16} />
                  </div>
                  <h4 className="font-semibold text-gray-800">
                    {language === 'english' ? 'View Receipt' : 'पावती पहा'}
                  </h4>
                </div>
                <p className="text-sm text-gray-600">
                  {language === 'english' 
                    ? 'Available only for years with calculated tax. Shows detailed receipt with payment information.'
                    : 'केवळ गणित केलेल्या कराच्या वर्षांसाठी उपलब्ध. पेमेंट माहितीसह तपशीलवार पावती दर्शवते.'}
                </p>
              </div>
              
              <div className="bg-white rounded-lg p-4 border border-gray-200">
                <div className="flex items-center mb-2">
                  <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center mr-3">
                    <FiEdit className="text-green-600" size={16} />
                  </div>
                  <h4 className="font-semibold text-gray-800">
                    {language === 'english' ? 'Calculate/Edit' : 'गणना/सुधारा'}
                  </h4>
                </div>
                <p className="text-sm text-gray-600">
                  {language === 'english' 
                    ? 'Available for years without calculated tax. Click to calculate tax for that assessment year.'
                    : 'गणित न केलेल्या कराच्या वर्षांसाठी उपलब्ध. त्या मूल्यांकन वर्षासाठी कर मोजण्यासाठी क्लिक करा.'}
                </p>
              </div>
            </div>
            
            <div className="mt-4 pt-4 border-t border-blue-200">
              <div className="flex items-start">
                <MdWarning className="text-yellow-600 mr-2 mt-1" />
                <p className="text-sm text-gray-700">
                  {language === 'english'
                    ? 'Note: Once tax is calculated and submitted, it becomes read-only. For corrections, contact Grampanchayat  office.'
                    : 'टीप: एकदा कर गणित केला आणि सबमिट केल्यानंतर, तो फक्त वाचनासाठी बनतो. दुरुस्तीसाठी, नगरपालिका कार्यालयाशी संपर्क साधा.'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Fixed Status Bar */}
      <div className="fixed bottom-4 right-4 bg-white rounded-lg shadow-lg p-4 border border-gray-200 max-w-sm z-40 hover:shadow-xl transition-shadow duration-300">
        <div className="flex items-center space-x-3">
          <div className={`w-3 h-3 rounded-full animate-pulse ${
            selectedYear && taxHistory[selectedYear]?.status === 'calculated' 
              ? 'bg-green-500' 
              : selectedYear && taxHistory[selectedYear]?.status === 'calculating'
              ? 'bg-purple-500'
              : 'bg-red-500'
          }`}></div>
          <div>
            <p className="font-medium text-sm text-gray-800">
              {selectedYear 
                ? (taxHistory[selectedYear]?.status === 'calculated'
                    ? (language === 'english' ? 'Tax Calculated' : 'कर गणित केला')
                    : taxHistory[selectedYear]?.status === 'calculating'
                    ? (language === 'english' ? 'Calculating...' : 'गणना करत आहे...')
                    : (language === 'english' ? 'Tax Not Calculated' : 'कर गणित केलेला नाही'))
                : (language === 'english' ? 'Select Assessment Year' : 'मूल्यांकन वर्ष निवडा')}
            </p>
            <p className="text-xs text-gray-500">
              {language === 'english' 
                ? 'Government of Maharashtra - Property Tax System'
                : 'महाराष्ट्र शासन - मालमत्ता कर प्रणाली'}
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 pt-6 border-t border-gray-200">
        <div className="text-center text-sm text-gray-500">
          <p>
            {language === 'english' 
              ? '© 2024 Government of Maharashtra - Urban Development Department. All rights reserved.'
              : '© २०२४ महाराष्ट्र शासन - शहरी विकास विभाग. सर्व हक्क राखीव.'}
          </p>
          <p className="mt-1">
            {language === 'english'
              ? 'Property Tax History Management System | Version 2.1.4'
              : 'मालमत्ता कर इतिहास व्यवस्थापन प्रणाली | आवृत्ती २.१.४'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TaxHistory;